import { __ } from '@wordpress/i18n';
import { useContext, useCallback } from 'preact/hooks';

import { AppContext } from '../../context/AppContext';
import { ProgramTerm } from '../../../../types';

export default function LegacyProgramFilter( { wpProgramTerms }: {wpProgramTerms: ProgramTerm[]} ) {
	const { filterContext } = useContext( AppContext );
	const [ filterState, dispatch ] = filterContext;

	const handleChange = useCallback( ( event: Event ) => {
		const input = event.target as HTMLInputElement;
		const isChecked = input.checked;
		dispatch( { type: 'SET_LEGACY_PROGRAMS', payload: isChecked } );
	}, [ ] );

	const hasProgramTerms = wpProgramTerms?.length > 0;

	return (
		<div className="tcc-map__filter tcc-map__filter--legacy-programs">
			<div className="tcc-map__checkbox-wrapper">
				<input
					type="checkbox"
					id={ `tcc-map__checkbox--legacy-programs` }
					checked={ filterState.legacyPrograms }
					onChange={ ( event ) => handleChange( event ) }
					disabled={ ! hasProgramTerms }
				/>
				<label htmlFor={ `tcc-map__checkbox--legacy-programs` }>{ __("Show Legacy Work") }</label>
			</div>
		</div>
	);
}
